/**
 * External dependencies
 */

import { get, values } from 'lodash';


export const getAllWebPlans = (state) => values(get(state, ['webPlans', 'items']));

export const requestingWebPlans = (state) => get(state, ['webPlans', 'requesting']);

export const errorRequestingWebPlans = (state) => get(state, ['webPlans', 'error']);